import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { StatusBanner } from '@/components/ui/status-banner';
export function NudgeUnique() {
  const $ = _c(7);
  const t = useTranslations("launchpad.uniqueMarket");
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("subtitle");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <StatusBanner tone="success" title={t0} description={t1} />;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}